var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('counter-record-image',{attrs:{"record":_vm.getLastCounterRecordsGroupItem(_vm.item.last)}})}
var staticRenderFns = []

export { render, staticRenderFns }